__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "edc-micro";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vue/devtools-api", "6.1.0", function() { return __webpack_require__.e(689).then(function() { return function() { return __webpack_require__(5689); }; }); });
			register("amazon-cognito-auth-js", "1.3.3", function() { return __webpack_require__.e(362).then(function() { return function() { return __webpack_require__(2362); }; }); });
			register("aos", "2.3.4", function() { return __webpack_require__.e(711).then(function() { return function() { return __webpack_require__(2711); }; }); });
			register("axios", "0.21.4", function() { return __webpack_require__.e(669).then(function() { return function() { return __webpack_require__(9669); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(935), __webpack_require__.e(407)]).then(function() { return function() { return __webpack_require__(3935); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(294).then(function() { return function() { return __webpack_require__(7294); }; }); });
			register("vue-router", "4.0.14", function() { return Promise.all([__webpack_require__.e(460), __webpack_require__.e(119)]).then(function() { return function() { return __webpack_require__(2119); }; }); });
			register("vue", "3.2.31", function() { return __webpack_require__.e(821).then(function() { return function() { return __webpack_require__(821); }; }); });
			register("vuex", "4.0.2", function() { return Promise.all([__webpack_require__.e(460), __webpack_require__.e(894)]).then(function() { return function() { return __webpack_require__(894); }; }); });
			initExternal(4506);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};